import {
  Component,
  ComponentRef,
  HostListener,
  Injector,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { QuarterSelectorOverlayComponent } from './quarter-selector-overlay/quarter-selector-overlay.component';
import { QuarterSelectorStateService } from './quarter-selector-overlay/quarter-selector.state';
import { RangeQuarterSelectorService } from './range-quarter-selector.service';

@Component({
  templateUrl: 'range-quarter-selector.component.html',
  styleUrls: ['range-quarter-selector.component.scss'],
  standalone: false,
})
export class RangeQuarterSelectorComponent implements OnInit, OnDestroy {
  @ViewChild('selectorContainer', { read: ViewContainerRef, static: true })
  private container: ViewContainerRef;
  private minSelector: ComponentRef<QuarterSelectorOverlayComponent> = null;
  private maxSelector: ComponentRef<QuarterSelectorOverlayComponent> = null;

  constructor(
    private parentInjector: Injector,
    private stateService: RangeQuarterSelectorService
  ) {}

  @HostListener('document:keydown', ['$event']) private handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape' || event.key === 'Tab') {
      this.stateService.close();
    }
  }

  ngOnInit() {
    const minService = this.stateService.getMinService();
    const minInjector: Injector = Injector.create({
      providers: [{ provide: QuarterSelectorStateService, useValue: minService, deps: [] }],
      parent: this.parentInjector,
    });
    this.minSelector = this.container.createComponent(QuarterSelectorOverlayComponent, { injector: minInjector });

    if (!this.stateService.isSingleSelection) {
      const maxService = this.stateService.getMaxService();
      minService.label = 'From';
      maxService.label = 'To';
      const maxInjector: Injector = Injector.create({
        providers: [{ provide: QuarterSelectorStateService, useValue: maxService, deps: [] }],
        parent: this.parentInjector,
      });
      this.maxSelector = this.container.createComponent(QuarterSelectorOverlayComponent, { injector: maxInjector });
    }
  }

  ngOnDestroy() {
    if (this.minSelector) {
      this.minSelector.destroy();
      this.minSelector = null;
    }

    if (this.maxSelector) {
      this.maxSelector.destroy();
      this.maxSelector = null;
    }
    this.container.clear();
    this.container = null;
  }
}
